module.exports = __webpack_public_path__ + "img/coming-soon.e5d6c486.gif";